function createYoutubeIframe(id, title) {
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&modestbranding=1&playsinline=1&enablejsapi=1`;
  iframe.title = title;
  iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
  iframe.allowFullscreen = true;
  return iframe;
}

// Poster that swaps itself for the iframe when clicked anywhere, and back again when the video ends.
// The play button keeps it keyboard accessible.
if (!customElements.get('youtube-embed')) {
  customElements.define(
    'youtube-embed',
    class YoutubeEmbed extends HTMLElement {
      connectedCallback() {
        this.onMessage = this.onMessage.bind(this);
        this.addEventListener('click', () => this.play(), { once: true });
        this.loadTitle();
      }

      async loadTitle() {
        const heading = this.querySelector('[data-youtube-title]');
        if (!heading) return;

        try {
          const url = encodeURIComponent(`https://youtu.be/${this.dataset.youtubeId}`);
          const response = await fetch(`https://www.youtube.com/oembed?url=${url}&format=json`, { credentials: 'omit' });
          const { title } = await response.json();
          heading.textContent = title.split(' | ')[0];
          this.dataset.title = title;
        } catch {
          // Heading stays empty when the title can't be fetched.
        }
      }

      play() {
        this.poster = [...this.childNodes];
        this.iframe = createYoutubeIframe(this.dataset.youtubeId, this.dataset.title);
        // Asks the player to post its state changes back to this window.
        this.iframe.addEventListener('load', () =>
          this.iframe.contentWindow.postMessage(JSON.stringify({ event: 'listening' }), '*')
        );
        window.addEventListener('message', this.onMessage);
        this.replaceChildren(this.iframe);
        this.iframe.focus();
      }

      onMessage(event) {
        if (event.source !== this.iframe.contentWindow || typeof event.data !== 'string') return;

        const { event: type, info } = JSON.parse(event.data);
        const state = type === 'onStateChange' ? info : info?.playerState;
        if (state === 0) this.reset();
      }

      reset() {
        window.removeEventListener('message', this.onMessage);
        this.replaceChildren(...this.poster);
        this.addEventListener('click', () => this.play(), { once: true });
        this.querySelector('button').focus({ preventScroll: true });
      }
    }
  );
}

// Dialog opened by any button with aria-controls pointing at it and a data-youtube-id.
if (!customElements.get('youtube-lightbox')) {
  customElements.define(
    'youtube-lightbox',
    class YoutubeLightbox extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.frame = this.querySelector('.youtube-lightbox__frame');

        this.dialog.addEventListener('click', (event) => event.target === this.dialog && this.dialog.close());
        this.dialog.addEventListener('close', () => this.onClose());
        this.querySelector('.youtube-lightbox__close').addEventListener('click', () => this.dialog.close());
      }

      open(trigger) {
        this.trigger = trigger;
        this.frame.replaceChildren(createYoutubeIframe(trigger.dataset.youtubeId, trigger.getAttribute('aria-label')));
        document.body.classList.add('overflow-hidden');
        this.dialog.showModal();
      }

      onClose() {
        this.frame.replaceChildren();
        document.body.classList.remove('overflow-hidden');
        this.trigger?.focus();
      }
    }
  );

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-youtube-id][aria-controls]');
    if (trigger) document.getElementById(trigger.getAttribute('aria-controls'))?.open(trigger);
  });
}
